import "components/swell-icon"
import "components/wind-icon"
import "styles/feed.scss"
